(function() {
'use strict';

angular
    .module('parking')
    .service('parkingService', parkingService);


function parkingService($http,
                        $q,
                        analytics,
                        dateUtil,
                        guidService,
                        occupancyService,
                        parkingSearchValidator,
                        searchUnitService,
                        tripService,
                        loggingService) {
    const domain = TRPCONFIG.Domain;
    const service = {
        getParkingQuotes,
        getParkingQuotesFromSession,
        validateSearchCriteria,
        clearSearchResults,
        getSearchResults
    };
    let results;

    function clearSearchResults() {
        results = null;
    }

    function getSearchResults(tripId) {
        if (results && results !== 'null') {
            return $q.when(results);
        }
        return getParkingQuotes(tripId);
    }

    function getParkingQuotes(tripId, request = _buildStandaloneParkingRequest()) {
    // `request` argument supplied in holiday mode i.e. basketService.getParkingQuotes()
        // Availability request format
        const availabilityReq = angular.extend({
            DomainId: domain.DomainId,
            CultureCode: domain.CultureCode
        }, request);

        // Trip service format
        const tripServiceReq = angular.extend({
            Airport: searchUnitService.getSelectedDepartureAirport()
        }, request);
        delete tripServiceReq.AirportCode;

        tripService.recordParkingSearch(tripId, tripServiceReq);
        analytics.startTimer('ParkingAvailabilityRequest');

        return $http.post('/api2/airportparking/availability/get', availabilityReq, { ignoreErrors: true })
            .then(res => {
                if (res.data.CarParkingQuotes.length === 0) {
                    loggingService.logError(`No airport parking information found for ${tripId}, fn.getParkingQuotes`);
                }
                analytics.endTimer('ParkingAvailabilityRequest');
                return _enrichData(res.data.CarParkingQuotes, availabilityReq.DepartureDate, availabilityReq.ReturnDate);
            }, () => {
                return null;
            });
    }

    function getParkingQuotesFromSession(availabilitySearchId, availabilityRequest) {
        return $http.post('/api2/airportparking/availability/getfromsession',
            { AvailabilitySearchId: availabilitySearchId },
            { ignoreErrors: true }
        ).then(results => {
            if (results.data.CarParkingQuotes.length === 0) {
                loggingService.logError(`No airport parking information found for ${availabilitySearchId}, fn.getParkingQuotesFromSession`);
            }
            return _enrichData(results.data.CarParkingQuotes,
                                availabilityRequest.DepartureDate,
                                availabilityRequest.ReturnDate);
        }, () => {
            return null;
        });
    }

    function validateSearchCriteria() {
        return parkingSearchValidator.validate(
            searchUnitService.getSelectedDepartureAirport(),
            searchUnitService.startDate(searchUnitService.parking),
            searchUnitService.endDate(searchUnitService.parking)
        );
    }

    function _buildStandaloneParkingRequest() {
        const departureAirport = searchUnitService.getSelectedDepartureAirport();
        return {
            AvailabilitySearchId: guidService.uuid(),
            DepartureDate: searchUnitService.startDate(searchUnitService.parking),
            ReturnDate: searchUnitService.endDate(searchUnitService.parking),
            AirportCode: departureAirport && departureAirport.Code,
            PassengerCount: occupancyService.getPassengerCount()
        };
    }

    function _enrichData(parkings, fromDate, toDate) {
        const days = dateUtil.getDifferenceInDays(dateUtil.parseDate(fromDate), dateUtil.parseDate(toDate));
        angular.forEach(parkings, function(parking) {
            parking.PerDayPrice = parking.Price / days;
        });
        return parkings;
    }

    return service;
}
})();
